import { Endpoint } from '../endpoint';
import { GroupId, GroupUserId, GroupUserResponse } from '@business/entities/group';

export function fetchGroupUsers(groupId: GroupId, isCompact?: boolean, filter?: string) {
  return Endpoint.get<GroupUserResponse[]>(`@makh/group-users`, { params: { groupId, isCompact, filter } });
}

export function fetchGroupUser(id: GroupUserId) {
  return Endpoint.get<GroupUserResponse>(`@makh/group-users/group-user/${id}`);
}

export function createGroupUser(data: Partial<GroupUserResponse>) {
  return Endpoint.post<GroupUserResponse>(`@makh/group-users`, { data });
}

export function updateGroupUser(groupUserId: GroupUserId, data: Partial<GroupUserResponse>) {
  return Endpoint.patch<GroupUserResponse>(`@makh/group-users/${groupUserId}`, { data });
}

export function deleteGroupUser(groupUserId: GroupUserId) {
  return Endpoint.delete<void>(`@makh/group-users/${groupUserId}`);
}
